import axios from "axios";
import { AuthConstant } from "../shared/constants/all-constant";
import { apiMethods } from "../shared/constants/api-constant";
import { AppConfigurationHelper } from "./AppConfigurationHelper";
import store from "../store/store";
import { logout } from "../store/loginSlice";
import { toast } from "../store/toastSlice";
import { AlertType } from "../shared/constants/enums";
import { CommonFunctions } from "../shared/utils/CommonFunctions";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: AppConfigurationHelper.Instance().APITimeOutInSeconds * 1000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(AuthConstant.AUTH_TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const err = error?.response?.data?.errorList[0] || "";
    if (
      error &&
      error.response?.status === 403 &&
      err.includes("Unauthorized")
    ) {
      store.dispatch(logout());
      CommonFunctions.clearLocalStorage();
      store.dispatch({ type: "RESET" });
      store.dispatch(
        toast({
          isOpen: true,
          message: err,
          type: AlertType.ERROR,
        })
      );
    }
    return Promise.reject(error);
  }
);

const requestMethods = async (method: string, url: string, data = null) => {
  try {
    const response = await axiosInstance.request({ method, url, data });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const restApiService = {
  get: (url: string) => requestMethods(apiMethods.GET, url),
  post: (url: string, data: any) => requestMethods(apiMethods.POST, url, data),
  put: (url: string, data: any) => requestMethods(apiMethods.PUT, url, data),
  delete: (url: string, data: any) =>
    requestMethods(apiMethods.DELETE, url, data),
};

export default restApiService;
